import * as z from "zod";

export const getLandmarkGlobalIntegration = {
  name: "getLandmarkGlobalIntegration" as const,
  input: z.object({}),
  output: z.object({ exists: z.boolean() }),
};
